import { Avatar } from "@narmi/design_system";

import { getInitials } from "../../utilities/name";
import { getTimeToNowString } from "../../utilities/time";

import styles from "./InboxMessage.module.css";

interface InboxMessageProps {
  id: string;
  name: string;
  message: string;
  secondaryMessage?: string;
  selected?: boolean;
  status?: "unread" | "read";
  time: string;
  onClick: (messageId: string) => void;
}

function InboxMessage({
  id,
  name,
  message,
  secondaryMessage,
  selected,
  status,
  time,
  onClick,
}: InboxMessageProps) {
  return (
    <div
      className={`${styles.inboxMessage} ${selected ? styles.selected : ""}`}
      onClick={() => onClick(id)}
    >
      <div className={styles.avatar}>
        <Avatar initials={getInitials(name)} label={name} size="m" />
      </div>

      <div className={styles.content}>
        <div
          className={`fontSize--s ${status === "unread" ? "fontWeight--bold" : "fontWeight--normal"}`}
        >
          {status === "unread" ? <div className={styles.indicator} /> : null}
          <span>{message}</span>
        </div>
        <div className="fontSize--xs">{secondaryMessage}</div>
      </div>
      <div className={styles.time}>{getTimeToNowString(time)}</div>
    </div>
  );
}

export { InboxMessage };
